import "./style.scss";
import { FC } from "react";
import { AOPShengenAdmissionData } from "@/src/types/admissionOffice";
import backForShengenAdmissionWithQr from "@/src/assets/admissionOfficePage/back-for-shengen-admission-with-qr.png";
import backForShengenAdmission from "@/src/assets/admissionOfficePage/back-for-shengen-admission.png";

interface AOPPrevProps {
  bodyForPrev: AOPShengenAdmissionData;
  withQR?: boolean;
}

const AOPPrev: FC<AOPPrevProps> = ({ bodyForPrev, withQR = true }) => {
  const actualBg = withQR ? backForShengenAdmissionWithQr : backForShengenAdmission;
  const dateLine = bodyForPrev.currentDate ? bodyForPrev.currentDate : "-";

  return (
    <div className="admission-office-prev-wrapper">
      <div className="admission-office-prev shengen admission">
        <img className="admission-office-prev-background" src={actualBg} alt="" />
        <div className="admission-office-prev-section title">ADMISSION/CONFIRMATION LETTER</div>
        <div className="admission-office-prev-section number-and-date">
          <span>№ -</span>
          <span>Date: {dateLine}</span>
        </div>
        <div className="admission-office-prev-section info">
          <p>Full Name: {bodyForPrev.fullName || ""}</p>
          <p>Data of Birth: {bodyForPrev.dateOfBirth || ""}</p>
          <p>Nationality: {bodyForPrev.nationality || ""}</p>
          <p>Course: {bodyForPrev.course || ""}</p>
          <p>Medium of Instruction: {bodyForPrev.mediumOfInstruction || ""}</p>
          <p>Duration: {bodyForPrev.duration || ""}</p>
        </div>
        {bodyForPrev.body?.length ? (
          <div className="admission-office-prev-section body-content">
            {bodyForPrev.body.map((item, idx) => (
              <div key={idx} dangerouslySetInnerHTML={{ __html: item }} />
            ))}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default AOPPrev;
